import React from 'react'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

const overdueInstitutionRange: Record<string, string> = {
  '0': '0',
  '1': '1-2',
  '2': '2-4',
  '3': '4+',
}

const overdueAmountRange: Record<string, string> = {
  '0': '0',
  '1': '0-1000',
  '2': '1000-2000',
  '3': '2000-3000',
  '4': '3000-5000',
  '5': '5000-7000',
  '6': '7000-11000',
  '7': '11000+',
}

const Field = ({ label, value }: { label: string; value?: string }) => (
  <div className="flex flex-col gap-1">
    <Text size="xs" c="dimmed">
      {label}
    </Text>
    <Text size="sm" className="text-gray-700" fw={500}>
      {value || '—'}
    </Text>
  </div>
)

const decode = (code: string, map: Record<string, string>) => map[code] ?? '—'

export default function OverdueLoan({ data }: { data: any }) {
  const theme = useTheme()
  const hasOverdue = data?.loan_info_xyp_cpl0044 === '1'

  return (
    <div className="mt-2">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        逾期情况
      </Text>
      <Stack gap="sm" className="mt-3">
        <div className="grid gap-3 md:grid-cols-2">
          <Field label="是否存在未结清逾期" value={hasOverdue ? '是' : '否'} />
          <Field label="当前逾期机构数" value={decode(data?.loan_info_xyp_cpl0071, overdueInstitutionRange)} />
          <Field label="当前逾期金额(元)" value={decode(data?.loan_info_xyp_cpl0072, overdueAmountRange)} />
        </div>
      </Stack>
    </div>
  )
}
